import React, { useState, useRef, useEffect, useContext } from "react";
import "./../../About/OurStory/OurStory.css";
import "./InvestorCharter.css";
import { Container, Col, Row, Table } from "react-bootstrap";
import URLstateContext from "../../../provider/CommonContext";
import { Link } from "react-router-dom";
import { saveAs } from "file-saver";

// import pdf1 from "./../../../pdf/Investor_Charter_for_Depository-Participant.pdf";
// import pdf2 from "./../../../pdf/INVESTOR-CHARTER-FOR-RESEARCH-ANALYST.pdf";
// import pdf3 from "./../../../pdf/INVESTOR-CHARTER-FOR-STOCK-BROKER.pdf";
// import pdf4 from "./../../../pdf/637925479754460915_Grievances Research Analyst.pdf";
// import pdf5 from "./../../../pdf/637925480068387998_GRIEVANCES MSBL.pdf";
// import pdf6 from "./../../../pdf/637925480385571674_GRIEVANCES MSFL.pdf";
// import pdf7 from "./../../../pdf/637925480707925988_GRIEVANCES MCFPL.pdf";
import pdfFirst from "./../../../pdf/Grievances-Research-Analyst.pdf"



function InvestorCharter() {

  const { BaseLiveURL } = useContext(URLstateContext);
  const colorRed = {
    color: "red",
    fontSize: "12px",
  };
  const newcolor = {
    color: "blue",
    fontSize: "21px",
  };
  //const refElement = useRef("");
  const [section, setsection] = useState(false);
  const [pdf_data, setPdfData] = useState([]);
  const [data, setData] = useState([]);
  const [data1, setData1] = useState([]);
  const [data2, setData2] = useState([]);
  const [data3, setData3] = useState([]);
  const [data4, setData4] = useState([]);


  const [dataColor, setDataColor] = useState(colorRed);
  const [ismonthly, setismonthly] = useState(false);
  const [isdisclosure, setisdisclosure] = useState(false);
  const [nodatafound, setnodatafound] = useState(false);
  const clickHandler = () => {
    setDataColor(newcolor);
    //console.log("here it comes");
    //refElement.current.style.color = "red";
  };
  const monthlyComplaints = () => {
    setismonthly(true);
    setisdisclosure(false);
  }
  const monthlyComplaintsDisclosure = () => {
    setisdisclosure(true);
    setismonthly(false);
  }


  useEffect(() => {

    postData('/api/Login/investorcharter', { sectionid: "1" })
      .then((data) => {
        if (data.data != null && data.data.length > 0) {
          setData(data.data);
          //console.log("data1: ", data)
        }
        else { setData(null) }
      });
  }, []);

  useEffect(() => {

    postData('/api/Login/investorcharter', { sectionid: "2" })
      .then((data1) => {
        if (data1.data != null && data1.data.length > 0) {
          setData1(data1.data);
          // console.log("data2: ", data1)
        }
        else { setData1(null) }
      });
  }, []);

  useEffect(() => {

    postData('/api/Login/investorcharter', { sectionid: "3" })
      .then((data2) => {
        if (data2.data != null && data2.data.length > 0) {
          setData2(data2.data);
          // console.log("data3: ", data2)
        }
        else { setData2(null) }
      });
  }, []);

  useEffect(() => {

    postData('/api/Login/investorcharter', { sectionid: "4" })
      .then((data3) => {
        if (data3.data != null && data3.data.length > 0) {
          setData3(data3.data);
          // console.log("data4: ", data3)
        }
        else { setData3(null) }
      });
  }, []);

  useEffect(() => {

    postData('/api/Login/investorcharter', { sectionid: "5" })
      .then((data4) => {
        if (data4.data != null && data4.data.length > 0) {
          setData4(data4.data);
          //  console.log("data5: ", data4)
        }
        else { setData4(null) }
      });
  }, []);

  async function postData(url = '', data = {}) {

    const response = await fetch(url, {
      method: 'POST', // *GET, POST, PUT, DELETE, etc.
      mode: 'cors', // no-cors, *cors, same-origin
      cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
      credentials: 'same-origin', // include, *same-origin, omit
      headers: {
        'Content-Type': 'application/json'
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      redirect: 'follow', // manual, *follow, error
      referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      body: JSON.stringify(data) // body data type must match "Content-Type" header

    });
    // console.log(response, "careerdata");
    return response.json(); // parses JSON response into native JavaScript objects

  }


  return (
    <>
      <section className="our-story-block disclaimer">
        <Container>
          <Row>
            <Col md={{ span: 12, offset: 0 }}>
              <div className="our-story-inner investor-charter">
                <h2>Investor Charter and Disclosures</h2>
                <ul>
                  {(data === null) ? <h5 className="errormsgComNew">No Data Available !!!</h5> : ''}
                  {/* {data && data.map(({ fileupload, type }) => (
                    <li>
                      <a href={BaseLiveURL + "pdf/" + fileupload} target="_blank">
                        {type}
                      </a>
                    </li>
                  )
                  )} */}
                   <li>
                      <a href={BaseLiveURL + "files/Annexure_A.pdf"} target="_blank">
                      Investor charter for Depository participants
                      </a>
                    </li>
                  {(data1 === null) ? <h5 className="errormsgComNew">No Data Available !!!</h5> : ''}
                  {data1 && data1.map(({ fileupload, type }) => (
                    <li>
                      <a href={BaseLiveURL + "pdf/" + fileupload} target="_blank">
                        {type}
                      </a>
                    </li>
                  )
                  )}
                  {(data2 === null) ? <h5 className="errormsgComNew">No Data Available !!!</h5> : ''}
                  {data2 && data2.map(({ fileupload, type }) => (
                    <li>
                      <a href={BaseLiveURL + "pdf/" + fileupload} target="_blank">
                        {type}
                      </a>
                    </li>
                  )
                  )}
                  <li>
                    <a className={ismonthly ? "tabactive" : "textwhite"} onClick={() => monthlyComplaints()} >
                      Monthly Complaints Disclosure
                    </a>
                  </li>
                  <li>
                    <a className={isdisclosure ? "tabactive" : "textwhite"} onClick={() => monthlyComplaintsDisclosure()} >
                      Disclosure
                    </a>
                  </li>
                </ul>
                {(ismonthly) ? (data3 === null) ? <h5 className="errormsgComNew">No Data Available !!!</h5> :
                  <Table bordered>
                    {data3 && data3.map(({ fileupload, section }) => (
                      <tbody>
                        <tr>
                          <td>{section}</td>
                          <td>
                            <a href={BaseLiveURL + "pdf/" + fileupload} target="_blank">
                              View
                            </a>
                          </td>
                          <td>
                            <a href={BaseLiveURL + "pdf/" + fileupload} target="_blank" download>download
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    ))}
                  </Table> : ''}
                {(isdisclosure) ? (data4 === null) ? <h5 className="errormsgComNew">No Data Available !!!</h5> :
                  <Table bordered>
                    {data4 && data4.map(({ fileupload, heading }) => (
                      <tbody>
                        <tr>
                          <td>{heading}</td>
                          <td>
                            <a href={BaseLiveURL + "pdf/" + fileupload} target="_blank">
                              View
                            </a>
                          </td>
                          <td>
                            <a href={BaseLiveURL + "pdf/" + fileupload} target="_blank" download>download
                            </a>
                          </td>
                        </tr>
                      </tbody>
                    ))}
                  </Table> : ''}
              </div>
              {/* <input ref={refElement} type="text" placeholder="add text here" /> */}
              {/* <p style={data}>onclick btn text color change</p>
              <button type="button" onClick={clickHandler}>
                some text
              </button> */}
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
}
export default InvestorCharter;
